'use client';

import { motion } from 'framer-motion';
import { Card, CardContent } from '@/components/ui/card';
import { Clock, DollarSign, Heart } from 'lucide-react';
import { useTranslation } from '@/hooks/useTranslation';

export default function QuickOverviewSection() {
    const { t } = useTranslation('root-canal');
    
    const overviewItems = [
        {
            icon: Clock,
            titleKey: 'quickOverview.treatmentTime.title',
            valueKey: 'quickOverview.treatmentTime.value',
            descriptionKey: 'quickOverview.treatmentTime.description'
        },
        {
            icon: Heart,
            titleKey: 'quickOverview.recovery.title',
            valueKey: 'quickOverview.recovery.value',
            descriptionKey: 'quickOverview.recovery.description'
        },
        {
            icon: DollarSign,
            titleKey: 'quickOverview.pricing.title',
            valueKey: 'quickOverview.pricing.value',
            descriptionKey: 'quickOverview.pricing.description'
        }
    ];

    return (
        <section className="py-12 bg-slate-50 dark:bg-slate-900 border-t border-slate-200 dark:border-slate-800">
            <div className="container">
                <div className="grid md:grid-cols-3 gap-6">
                    {overviewItems.map((item, index) => (
                        <motion.div
                            key={index}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ delay: index * 0.1, duration: 0.5 }}
                            viewport={{ once: true }}
                        >
                            <Card className="h-full border-0 shadow-sm hover:shadow-md transition-all duration-300 bg-white/50 dark:bg-slate-800/50 backdrop-blur-sm">
                                <CardContent className="p-6 text-center">
                                    <div className="w-12 h-12 bg-gold/10 rounded-full flex items-center justify-center mx-auto mb-4">
                                        <item.icon className="w-6 h-6 text-gold" />
                                    </div>
                                    <h3 className="font-semibold text-navy dark:text-white mb-2">
                                        {t(item.titleKey)}
                                    </h3>
                                    <div className="text-2xl font-bold text-gold mb-2">
                                        {t(item.valueKey)}
                                    </div>
                                    <p className="text-sm text-slate-500 dark:text-slate-400">
                                        {t(item.descriptionKey)}
                                    </p>
                                </CardContent>
                            </Card>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
} 